module.exports = __webpack_public_path__ + "static/media/icon-iam-logo.ab1fb223.jpg";